import React, { createContext, useContext, ReactNode } from 'react';

export interface ProjectionContextInterface {
  displayProjection: string;
  dataProjection: string;
}

const ProjectionContext = createContext<ProjectionContextInterface | undefined>(
  undefined
);

interface ProjectionProviderProps {
  children: ReactNode;
  displayProjection?: string;
  dataProjection?: string;
}

export const ProjectionProvider: React.FC<ProjectionProviderProps> = ({
  children,
  displayProjection = 'EPSG:3857', // Web Mercator (default for most web maps)
  dataProjection = 'EPSG:4326', // WGS84 (lat/lon)
}) => {
  const value: ProjectionContextInterface = React.useMemo(
    () => ({
      displayProjection,
      dataProjection,
    }),
    [displayProjection, dataProjection]
  );

  return (
    <ProjectionContext.Provider value={value}>
      {children}
    </ProjectionContext.Provider>
  );
};

export function useProjectionContext(): ProjectionContextInterface {
  const context = useContext(ProjectionContext);
  if (context == null) {
    throw new Error(
      'No context provided: useProjectionContext() can only be used in a descendant of <ProjectionProvider>'
    );
  }
  return context;
}
